import axios from "axios"

export const getFiltersService = (request) => {
	return axios
		.get("/filter", {
			params: request.data.queryParams(),
		})
		.then((response) => {
			return response
		})
		.catch((err) => {
			return err.response.data
		})
}
